import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { adminServices } from "../../services/adminServices";
import { UserObj } from "../../services/localStarage";
import AlertComponent from "../alert/alert";
import { onboardingServices } from "../../services/onboardingServices";
import { Backdrop, CircularProgress } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PersonalDetail from "./personalDetail";
import DigitalSignature from "./digitalSignature";
import MyDetails from "./myDetails";


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function Profile() {
  const userRole = UserObj ? UserObj?.role?.name : "";
  const { id } = useParams();
  const [selectedFile, setSelectedFile] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [lastModified, setLastModified] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setprofileData] = useState('');
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    handleUpload(e.target.files[0]);
  };

  const handleUpload = (uploadFile) => {
    let formData = new FormData();
    formData.append("file", uploadFile);
    if (formData) {
      setIsLoading(true);
      onboardingServices
        .uploadFile(formData)
        .then(function (response) {
          const uploadKey = response?.data?.data?.data?.key;
          if (uploadKey) {
            let profilePic = {
              profilePic: uploadKey
            };
            let vId = UserObj?._id;
            adminServices
              .uploadFile(profilePic, id)
              .then(function (response) {
                if (response?.data?.success === true) {
                  setProfileImage((response?.data?.profilePic));
                  openAlert(true, "success", `${response?.data?.message}`);
                  setLastModified(`${response?.data?.updatedAt}`);
                  window.location.reload();
                }
              })
              .catch(function (error) {
                openAlert(true, "error", `${error?.response?.data?.message}`);
              })
              .finally((param) => {
                setIsLoading(false);
              });
          }
        })
        .catch(function (error) {
          openAlert(true, "error", error);
        });
    }
  };

  const handleDeleteImage = (e) => {
    if (profileData && profileData.profilePic) {
      let profilePic = {
        profilePic: ""
      };
      let vId = UserObj?._id;
      setIsLoading(true);
      adminServices
        .uploadFile(profilePic, id)
        .then(function (response) {
          if (response?.data?.success === true) {
            setProfileImage((response?.data?.profilePic));
            openAlert(true, "success", `${response?.data?.message}`);
            setLastModified(response?.data?.data?.updatedAt);
            window.location.reload();
          }
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
        })
        .finally((param) => {
          setIsLoading(false);
        });
      setProfileImage('');
      // setprofileData('');
      openAlert(true, "success", 'Uploaded file remove Successfully');
      setLastModified(null);
    } else {
      openAlert(true, "error", 'No image uploaded to delete. Please upload image first');
    }
  };

  useEffect(() => {
    getProfileDetails(id);
  }, [id]);

  const getProfileDetails = (loginId) => {
    setIsLoading(true);
    adminServices
      .getProfileData(loginId)
      .then((res) => {
        if (res.data.success === true) {
          setprofileData(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">

          <div className="profile_detail_vendor_body_data">
            <div className="lets_profile_status_detail">
              <h4 className="status_text_profiles"> My Profile </h4>
            </div>
            <p className="status_text_profile">
              Latest Modification Date : {lastModified ? lastModified : '01-05-2024'}
            </p>
          </div>
        </div>
        <div className="vendor_profile_admin_bbdt">
          <Box>
            <Box className="admin_dashboard_row2_tab ">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Personal and Contact Details" {...a11yProps(0)} />
                <Tab label="Digital Signature and Stamp" {...a11yProps(1)} />
                {userRole === "VENDOR" ? (
                  <Tab label="My Details" {...a11yProps(2)} />
                ) : null}
              </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
              <div className="vendor_profile_admin_bbdt_id">
                <PersonalDetail />
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <div className="vendor_profile_admin_bbdt_id">
                <DigitalSignature profileData={profileData} />

              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <div className="vendor_profile_admin_bbdt_id">

                <MyDetails />
              </div>
            </CustomTabPanel>
          </Box>
        </div>
      </div>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

    </>
  );
}

export default Profile;
